var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.50188 8.49992C8.8924 8.1094 9.52557 8.1094 9.91609 8.49992L12.0019 10.5857L14.0876 8.49992C14.4782 8.1094 15.1113 8.1094 15.5019 8.49992C15.8924 8.89045 15.8924 9.52361 15.5019 9.91414L13.4161 11.9999L15.5019 14.0857C15.8924 14.4762 15.8924 15.1094 15.5019 15.4999C15.1113 15.8904 14.4782 15.8904 14.0876 15.4999L12.0019 13.4141L9.91609 15.4999C9.52556 15.8904 8.8924 15.8904 8.50187 15.4999C8.11135 15.1094 8.11135 14.4762 8.50187 14.0857L10.5876 11.9999L8.50188 9.91414C8.11135 9.52361 8.11135 8.89045 8.50188 8.49992Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.002 12C22.002 17.5228 17.5248 22 12.002 22C6.47911 22 2.00195 17.5228 2.00195 12C2.00195 6.47715 6.47911 2 12.002 2C17.5248 2 22.002 6.47715 22.002 12ZM20.002 12C20.002 16.4183 16.4202 20 12.002 20C7.58368 20 4.00195 16.4183 4.00195 12C4.00195 7.58172 7.58368 4 12.002 4C16.4202 4 20.002 7.58172 20.002 12Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/closeIcon.fd390e01c82e56fb075060461a002adb.svg";
export { ForwardRef as ReactComponent };